import React from "react";

const PagamentoCancelado = () => {
  return (
    <div>
      <h1>Pagamento cancelado.</h1>
    </div>
  );
};

export default PagamentoCancelado;
